/* eslint-disable import/prefer-default-export */
export const mathJaxConfig21 = {
  config: ['MMLorHTML.js'],
  styleSheets: [],
  styles: {},
  jax: ['input/TeX'],
  extensions: ['tex2jax.js'],
  preJax: null,
  postJax: null,
  preRemoveClass: 'MathJax_Preview',
  showProcessingMessages: true,
  messageStyle: 'none',
  displayAlign: 'center',
  displayIndent: '0em',
  delayStartupUntil: 'none',
  skipStartupTypeset: true,
  elements: [],
  tex2jax: {
    inlineMath: [
      ['$$', '$$'], // uncomment this for standard TeX math delimiters
      ['\\(', '\\)'],
    ],
    displayMath: [['\\[', '\\]']],
    skipTags: ['script', 'noscript', 'style', 'textarea', 'pre', 'code'],
    ignoreClass: 'tex2jax_ignore',
    processClass: 'tex2jax_process',
    processEscapes: false,
    processEnvironments: true,
    preview: 'TeX',
  },

  mml2jax: {
    preview: 'alttext',
  },

  jsMath2jax: {
    preview: 'TeX',
  },

  TeX: {
    TagSide: 'right',
    TagIndent: '.8em',
    MultLineWidth: '85%',
    Macros: {},
    extensions: ['AMSmath.js', 'AMSsymbols.js', 'noUndefined.js'],
  },

  //  These parameters control the MathML input jax.
  MathML: {
    //  This specifies whether to use TeX spacing or MathML spacing when the
    //  HTML-CSS output jax is used.
    useMathMLspacing: false,
  },

  //  These parameters control the HTML-CSS output jax.
  'HTML-CSS': {
    scale: 100,
    availableFonts: ['STIX', 'TeX'],
    preferredFont: 'TeX',
    webFont: 'TeX',
    imageFont: 'TeX',
    undefinedFamily: 'STIXGeneral,"Arial Unicode MS",serif',
    showMathMenu: true,
    styles: {},
    tooltip: {
      delayPost: 600, // milliseconds delay before tooltip is posted after mouseover
      delayClear: 600, // milliseconds delay before tooltip is cleared after mouseout
      offsetX: 10,
      offsetY: 5, // pixels to offset tooltip from mouse position
    },
  },

  //  These parameters control the NativeMML output jax.
  NativeMML: {
    scale: 100,
    showMathMenu: true,
    showMathMenuMSIE: true,
    styles: {},
  },

  MathMenu: {
    delay: 400,
    helpURL: 'http://www.mathjax.org/help/user/',
    showRenderer: true,
    showFontMenu: false,
    showContext: false,
    windowSettings: {
      status: 'no',
      toolbar: 'no',
      locationbar: 'no',
      menubar: 'no',
      directories: 'no',
      personalbar: 'no',
      resizable: 'yes',
      scrollbars: 'yes',
      width: 100,
      height: 50,
    },
    styles: {},
  },

  MMLorHTML: {
    prefer: {
      MSIE: 'MML',
      Firefox: 'MML',
      Opera: 'HTML',
      other: 'HTML',
    },
  },
};
